var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MainHeader'),_c('div',{staticClass:"content-wrapper-vertical-center"},[_c('div',{staticClass:"content-width-70"},[_c('router-view')],1)]),_c('MainFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }